export default __webpack_public_path__ + "img/sagoo/sagoo11_1500.webp";